import * as React from 'react';
import { useMediaValue } from './components/themeContext';

type CarouselContext = {
  playCarousel: boolean;
  setPlayCarousel: React.Dispatch<React.SetStateAction<boolean>>;
};

export const carouselContext = React.createContext<CarouselContext>({
  playCarousel: true,
  setPlayCarousel: () => {},
});

carouselContext.displayName = "CarouselContext";

export function usePauseCarousel() {
  const { setPlayCarousel } = React.useContext(carouselContext);
  React.useEffect(() => {
    setPlayCarousel(false);
    return () => {
      setPlayCarousel(true);
    };
  }, [setPlayCarousel]);
}

export function useInitNavigation(
  isOpen: boolean,
  setIsOpen: (isOpen: boolean) => void
) {
  const { setPlayCarousel } = React.useContext(carouselContext);
  const media = useMediaValue(['xs', 'sm', 'md', 'lg'] as const);
  React.useEffect(() => {
    if (isOpen) {
      setIsOpen(false);
      setPlayCarousel(true);
    }
  }, [media, setIsOpen, setPlayCarousel]);
}
